'use client';

import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, LoadingButton, Typography } from '@eventbrite/marmalade';
import { Modal } from '@/components/_shared/Modal/Modal';
import styles from './RSVPModal.module.scss';

export type RsvpResponseType = 'maybe' | 'no';
export interface RSVPModalProps {
  visible: boolean;
  onClose: () => void;
  responseType: RsvpResponseType;
  eventId: string;
  mipaToken: string | null;
}

export const RSVPModal: React.FC<RSVPModalProps> = ({
  visible,
  onClose,
  responseType,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  eventId,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mipaToken,
}) => {
  const { formatMessage } = useIntl();
  const [note, setNote] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSend = async () => {
    setError(null);
    setIsSubmitting(true);
    try {
      //TODO: Call to RSVP API: EB-321331
      onClose();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Something went wrong');
    } finally {
      setIsSubmitting(false);
    }
  };

  const title =
    responseType === 'maybe'
      ? formatMessage({ id: 'Maybe', defaultMessage: 'Maybe', description: 'RSVP Maybe modal title' })
      : formatMessage({ id: 'No', defaultMessage: 'No', description: 'RSVP No modal title' });

  return (
    <Modal visible={visible} onClose={onClose} type="simple" title={title}>
      <div className={styles.content}>
        <Typography variant="body-md" as="p">
          <label htmlFor="rsvp-note">
            <FormattedMessage
              id="Add an optional note (optional)"
              defaultMessage="Add an optional note (optional)"
              description="RSVP modal note label"
            />
          </label>
        </Typography>
        <textarea
          id="rsvp-note"
          className={styles.noteField}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder=""
          aria-label="Optional note"
          disabled={isSubmitting}
        />
        {error && (
          <Typography variant="body-sm" color="error">
            {error}
          </Typography>
        )}
        <div className={styles.actions}>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting} className={styles.cancelButton}>
            <FormattedMessage id="Cancel" defaultMessage="Cancel" description="RSVP modal cancel" />
          </Button>
          <LoadingButton variant="primary" onClick={handleSend} isLoading={isSubmitting}>
            <FormattedMessage id="Send" defaultMessage="Send" description="RSVP modal send" />
          </LoadingButton>
        </div>
      </div>
    </Modal>
  );
};
